import React, { forwardRef, Ref } from 'react';

import cn from '@/lib/clsxm';

import Container from '@/components/@base/container';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import XImage from '@/components/@base/x-image';
import AddQuestionButton from '@/components/app/product/components/questions/add-question/add-question-btn';
import Props from '@/components/app/product/components/questions/question-header/type';
import RoundedIcon from '@/components/shared/components/icon/rounded';
import IconTextCombo from '@/components/shared/components/icon-text-combo';

import { DATA_CY_ADD_QUESTION_BUTTON } from '@/constant/cypress';
import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

function QuestionHeader({ className, onAddQuestionClick }: Props, ref?: Ref<HTMLDivElement>) {
  return (
    <Container center className={cn('mb-4 justify-between md:mb-[30px]', className)} ref={ref}>
      <IconTextCombo
        id='questions'
        Icon={
          <RoundedIcon
            icon={
              <XImage
                src={imagesList.icons.question}
                alt={productLocalization.questions}
                width={20}
                height={20}
              />
            }
          />
        }
        headingType={HEADING_TYPE.H2}
        title={productLocalization.questions}
        textClassName='text-base font-bold text-[#424B57]'
        wrapperClassName='max-w-max p-0'
      />

      <Container center className='gap-6'>
        <AddQuestionButton
          data-cy={DATA_CY_ADD_QUESTION_BUTTON}
          onAddQuestionClick={onAddQuestionClick}
        />
      </Container>
    </Container>
  );
}

export default forwardRef(QuestionHeader);
